import {IServiceFactory} from "../../../../service-factory.interface";
import {MealSsrBase} from "../meal-ssr-base";

//Meniu Pui asiatic cu orez
export default class VomlSsrType extends MealSsrBase {
    constructor(services: IServiceFactory) {
        super('VOML', services);
    }
}
